import { makeStyles } from '@mui/styles';

const ViewMessageDeleteStyles = makeStyles(() => ({
	root: {
		backgroundColor: 'rgba(255, 255, 255, 0.2)',
		alignItems: 'center',
		display: 'flex',
		height: '100vh',
		justifyContent: 'center',
		left: 0,
		position: 'fixed',
		top: 0,
		width: '100%',
		zIndex: 1301,
	},
	rootC: {
		backdropFilter: 'blur(3px)',
		background: 'rgba(0, 0, 0, 0.5)',
		height: '100%',
		left: 0,
		position: 'absolute',
		top: 0,
		width: '100%',
		zIndex: 1,
	},
	card: {
		backgroundColor: '#FFFFFF',
		zIndex: 1300,
		borderRadius: 10,
		width: 384,
		height: 111,
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		maxHeight: '91%',
		overflow: 'hidden',
	},
	buttonA: {
		width: 112,
		height: 32,
		boxShadow: '0px 1px 3px #00000029 !important',
		borderRadius: '10px !important',
		fontSize: '12px !important',
		fontWeight: '700 !important',
		fontFamily: 'Montserrat !important',
		textAlign: 'center',
		marginLeft: '40px !important',
		backgroundColor: '#FFFFFF !important',
		color: '#686868 !important',
	},
	buttonC: {
		width: 122,
		height: 32,
		backgroundColor: '#0D66B6 !important',
		boxShadow: '0px 1px 2px #00000029 !important',
		border: '1px solid #0000001F !important',
		borderRadius: '10px !important',
		fontSize: '12px !important',
		fontWeight: '700 !important',
		fontFamily: 'Montserrat !important',
		color: '#FFFFFF !important',
		marginLeft: '100px !important',
	},
	tittle: {
		fontfamily: 'Montserrat !important',
		fontWeight: '700 !important',
		fontSize: '16px',
		color: '#003C82',
		marginTop: '15px !important',
		letterSpacing: 0,
		textAlign: 'center',
	},
	button: {
		width: 103,
		height: 32,
		boxShadow: '0px 3px 3px #00000029 !important',
		borderRadius: '4px !important',
		fontSize: '12px !important',
		fontWeight: '600 !important',
		fontFamily: 'Montserrat !important',
		marginLeft: '195px !important',
	},
}));

export default ViewMessageDeleteStyles;
